import * as React from "react";
import { useTheme } from "styled-components";

import { Icon } from "src/library/components/Icon";
import { Text } from "src/library/components/Text";
import { Icons } from "src/library/components/Icon/types";
import {
  MenuContext,
  MenuContextType
} from "src/core/shared/hooks/menu/useMenu";

interface ContextTitleProps {
  currentContext: MenuContextType;
}
/** Context title */
export const ContextTitle: React.ReactFCWithChildren<ContextTitleProps> = ({ currentContext }) => {
  const [ _menuState, { removeCurrentContext } ] = React.useContext(MenuContext);
  const theme = useTheme();

  if (currentContext) {
    return (
      <div
        className="context-exit"
        onClick={() => {
          removeCurrentContext();
        }}
      >
        <Icon
          icon={Icons.CLOSE}
          $fillColor="white"
          size={20}
        />

        <Text color={theme.overrides?.menu?.textColor ? theme.overrides.menu.textColor : "white"}>
          {currentContext.title}
        </Text>
      </div>
    );
  }

  return null;
};
